export const baseApi = 'api'
export const baseChargeIntegrations = 'charge-integrations'
